
  <nz-form-item *ngIf="field">
    <nz-form-label
      [nzSm]="24"
      [nzXs]="24"
      [nzRequired]="field.Required"
      [nzNoColon]="true"
      [nzFor]="field.Code.toString()"
      style="display: flex; align-items: center; justify-content: flex-start;"
    >
    
      <label
      
        nz-checkbox
        [formGroup]="formGroup"
        *ngIf="isBulkEdit"
        ngModel="false"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="changeCheckbox($event)"
      >
        {{ "Change" }}
      </label>
      {{ field.Title }}
      &nbsp;&nbsp;
      <span nz-typography nzType="secondary" class="scope-label">
        [{{ field.Scope === "1" ? "Language" : "Global" }}]
      </span>
    </nz-form-label>
  
  
  
  
  
  
    
    <nz-row
      style="width: 100%"
      *ngIf="!isLoading && (field.Checked || !isBulkEdit)"
    >
      <span *ngIf="isBulkEdit" nz-col [nzSpan]="isBulkEdit ? 12 : 24">
        <span>
          <nz-row>
            <nz-form-label *ngIf="isBulkEdit" nz-col nzMd="6" nzSm="24"
              >From Value <small>[optional]</small></nz-form-label
            >
            <app-product-field
              nz-col
              nzMd="18"
              nzSm="24"
              [objectTypeId]="objectTypeId"
              [disabled]="isBulkEdit && !field.Checked"
              [record]="record"
              [formGroup]="formGroup"
              [field]="field"
              [controlName]="field.DataType + '.' + field.Code + '.from'"
              [dropDownsMetaData]="dropDownsMetaData"
            >
            </app-product-field>
          </nz-row>
        </span>
      </span>
      <span nz-col [nzSpan]="isBulkEdit ? 12 : 24">
        <nz-row>
          <nz-form-label
            nz-col
            nzSm="24"
            nzMd="4"
            style="text-align: center !important"
            *ngIf="isBulkEdit"
          >
            New Value
          </nz-form-label>
          <app-product-field
            nz-col
            nzSm="24"
            nzMd="20"
            [objectTypeId]="objectTypeId"
            [disabled]="isBulkEdit && !field.Checked"
            [record]="record"
            [formGroup]="formGroup"
            [field]="field"
            [controlName]="field.DataType + '.' + field.Code"
            [dropDownsMetaData]="dropDownsMetaData"
          >
          </app-product-field>
        </nz-row>
      </span>
    </nz-row>
    <ng-container *ngIf="isLoading && field.Checked">
      <nz-skeleton-element
        nzType="input"
        [nzActive]="true"
        style="width: 100%"
      ></nz-skeleton-element>
    </ng-container>
  </nz-form-item>